const icons = {
    advertenciaRed: require('./advertenciaRed.png'),
    advertenciaYellow: require('./advertenciaYellow.png'),
    ok: require('./ok.png'),
    addUser: require('./add-user.png'),
    enter: require('./enter.png'),
    eraser: require('./eraser.png'),
    home: require('./home.png'),
    information: require('./information.png'),
    pencil: require('./pencil.png'),
    search: require('./search.png'),
    book: require('./book.png'),
    clipboard: require('./clipboard.png'),
    login: require('./login.png'),

};

export default icons;
